import { render, staticRenderFns } from "./alarm-tool.vue?vue&type=template&id=8ed31588&"
import script from "./alarm-tool.vue?vue&type=script&lang=ts&"
export * from "./alarm-tool.vue?vue&type=script&lang=ts&"
import style0 from "./alarm-tool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports